/* This file exists to prevent a circular dependency between assignment-types and syllabus.utilities.
    The functions in this file could have been moved into
    assignment-types.shared.utilities.ts, but it depends on many other modules, and moving all of
    them would require a large refactor. To avoid that, the function is defined here so it can be
    consumed from the assignment-types folder without introducing a circular dependency.
*/
import { AssignmentDto } from '../../apis/eols-assessment-service/eols-assessment-service.dtos';
import { PrimaryTaxonomy } from '../../apis/rec-gateway/rec-gateway.models';
import { EvolveProductDto } from '../../apis/sherpath-app-facade-service/sherpath-app-facade-service.dtos';
import { CatalogWithExternalEntitiesDto, OsmosisTokenDto } from '../../apis/sherpath-course-management-service/sherpath-course-management-service.dtos';
import { SyllabusItemDto } from '../../apis/sherpath-syllabus-service/sherpath-syllabus-service.dtos';
import { getOsmosisTokenAndConfigPromise } from '../catalog/assignment-type-catalog-shared.utilities';
import { SherpathLessonOsmosisIncludesConfigs } from '../osmosis-video-editor/osmosis-video.constants';
import { getSyllabusItemDictionaryItem } from './syllabus.utilities';

export const getOsmosisTokenAndConfigPromiseForSyllabus = (props: {
  fetchOsmosisTokenAction: Function;
  isOsmosisVideosEnabled: boolean;
  syllabusItem: SyllabusItemDto;
  catalog: CatalogWithExternalEntitiesDto;
  assignments: AssignmentDto[];
  primaryTaxonomies: PrimaryTaxonomy[];
  evolveProducts: EvolveProductDto[];
}): Promise<{
  osmosisToken: OsmosisTokenDto;
  osmosisIncludesConfigs: SherpathLessonOsmosisIncludesConfigs;
}> => {

  const {
    syllabusItem,
    catalog,
    assignments,
    primaryTaxonomies,
    isOsmosisVideosEnabled,
    fetchOsmosisTokenAction,
    evolveProducts
  } = props;

  if (!isOsmosisVideosEnabled) {
    return Promise.resolve(null);
  }

  const dictionaryItem = getSyllabusItemDictionaryItem(syllabusItem, catalog, assignments, primaryTaxonomies, isOsmosisVideosEnabled, evolveProducts);
  return getOsmosisTokenAndConfigPromise({
    contentItem: dictionaryItem.catalogItem,
    catalog,
    isOsmosisVideosEnabled,
    fetchOsmosisTokenAction
  });
};
